module.exports = __webpack_public_path__ + "static/media/burger_family_deals-mb-en.d59fd867.jpg";